import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'PreferenceModal',
  props: {
    visible: { type: Boolean },
    selectedPosition: null
  },
  emits: ["close", "select"],
  setup(__props: any) {





return { __sfc: true, }
}

})